import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/videos';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const nameMap: Record<string, string> = {
  category: '内容分类',
  article: '文章详情',
  about: '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  pathSegments.forEach((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');

    if (segment === 'category') {
      breadcrumbs.push({ label: '内容分类', path });
    } else if (segment === 'article') {
      breadcrumbs.push({ label: '文章详情' });
    } else if (segment === 'about') {
      breadcrumbs.push({ label: '关于我们' });
    } else if (pathSegments[0] === 'category' && index === 1) {
      const cat = categories.find((c) => c.slug === segment);
      breadcrumbs.push({ label: cat?.name || segment, path });
    } else if (pathSegments[0] === 'article' && index === 1) {
      breadcrumbs.push({ label: '阅读文章' });
    } else {
      breadcrumbs.push({ label: nameMap[segment] || segment });
    }
  });

  return (
    <nav aria-label="面包屑导航" className="max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {breadcrumbs.map((item, idx) => (
          <li key={idx} className="flex items-center gap-1">
            {idx > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path && idx < breadcrumbs.length - 1 ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className={idx === breadcrumbs.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}